export default __webpack_public_path__ + "static/media/truck.f18b18ea.png";